import _ from 'lodash'
import config from 'scoreboard/components/config'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import formatValue from 'scoreboard/components/format-value'

/**
 * Formats a localized numeric value using the English locale for use on the
 * server side, if needed.
 * Returns the original value:
 *  - if the locale does not use different grouping or decimal separators or
 *  - if the value cannot be formatted as a number
 * @param value
 */
function formatLocalizedNumericValueForServer (value) {
	if (_.isNil(value) || _.isEmpty(value)) {
		return value
	}

	if (!usingLocalizedSeparators()) {
		return value
	}

	// try to format the possible number
	let formatted = formatNumericValueForLocalizedDisplay(value)
	// if it can't be formatted as a number, return the value as-is
	if (_.isEmpty(formatted)) {
		return value
	} else {
		// numericEvaluator will format the value using the English locale
		return numericEvaluator(formatted)
	}
}

/**
 * Formats a numeric value from English locale to the user's locale, if needed.
 * Returns the original value:
 *  - if the locale does not use different grouping or decimal separators or
 *  - if the value is not numeric
 * @param value
 * @param {String} [dataType] the dataType of the value
 */
function formatNumericValueForLocalizedDisplay(value, dataType) {
	if (_.isNil(value)) {
		return value
	}
	if (!usingLocalizedSeparators()) {
		// #40586 if dataType was specified for a numeric value, format the value
		if (dataType && isNumeric(value)) {
			return formatValue({value, precision: 'none', shorten:false, dataType })
		}
		return value
	}
	if (!isNumeric(value)) {
		return value
	}
	// formatValue will format using the user's locale
	return formatValue({value, precision:'none', shorten: false, dataType })
}

function usingLocalizedSeparators() {
	return config.decimalSeparator != '.' || config.groupingSeparator != ','
}

function isNumeric(n) {
	return _.isNil(numericValidator(n))
}

export { formatNumericValueForLocalizedDisplay }
export { formatLocalizedNumericValueForServer }

